import { render, staticRenderFns } from "./CoauthorForm.vue?vue&type=template&id=53bf008c&scoped=true&"
import script from "./CoauthorForm.vue?vue&type=script&lang=js&"
export * from "./CoauthorForm.vue?vue&type=script&lang=js&"
import style0 from "./CoauthorForm.vue?vue&type=style&index=0&id=53bf008c&scoped=true&lang=css&"
import style1 from "./CoauthorForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf008c",
  null
  
)

export default component.exports